// One-time "multi-day spotlight tutorial" seen flag.
//
// A lightweight, localStorage-backed marker (per user, per browser) so the
// planner's multi-day spotlight tour only ever launches once — mirrors
// utils/contentCommentsSeen.ts's storage pattern (prefix + try/catch, so a
// private-mode/localStorage-disabled browser degrades to "always unseen"
// rather than throwing).

const STORAGE_KEY_PREFIX = 'hiiker:planTrailMultiDayTutorialSeen:';

function storageKey(userKey: string): string {
  return `${STORAGE_KEY_PREFIX}${userKey}`;
}

export function hasSeenMultiDayTutorial(userKey: string): boolean {
  try {
    return window.localStorage.getItem(storageKey(userKey)) === '1';
  } catch {
    return false;
  }
}

export function markMultiDayTutorialSeen(userKey: string): void {
  try {
    window.localStorage.setItem(storageKey(userKey), '1');
  } catch {
    /* localStorage unavailable (private mode / disabled) — degrade silently */
  }
}
